/** @format */
import { getConfig } from '@toucan/common/services/nextjs/settings';

export const getPublicIntercomConfig = (preferConsolidatedConfig: boolean) => {
    const { publicRuntimeConfig } = getConfig();
    if (preferConsolidatedConfig && publicRuntimeConfig.intercomConsolidated) {
        return publicRuntimeConfig.intercomConsolidated;
    }
    return publicRuntimeConfig.intercom;
};
